import React, { useContext, useEffect, useState } from "react";
import Banner from "./Banner/Banner";
// import Method1 from "../Landing page/methods/Method1";
// import Method2 from "../Landing page/methods/Method2";
import { FaArrowAltCircleDown, FaArrowAltCircleUp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import '../../Pages/Home/Home.css'
// import TextSlider from "./TextSlider/TextSlider";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import Method1 from "../../Pages/Landing page/methods/Method1";
import Method2 from "../../Pages/Landing page/methods/Method2";
import MetaData_V2 from "../../Components_V2/MetaData/MetaData";

const Home_V2 = () => {
  const navigate = useNavigate();
  const {AIUser} = useContext(UserAuthContext);

  return (
    <div>
      <MetaData_V2
        pageTitle={
          "Smart Social Media Management AI Platform | AI Post Generator"
        }
        pageDescription={
          "Upgrade your social media presence with our top-rated social media management AI platform that delivers the best AI-generated posts. Sign up now!"
        }
        canonical="https://whalesai.com/"
      ></MetaData_V2>
     
      {/* button */}
      <div className="d-flex justify-content-center pt-4 pb-0 mb-0 px-4" style={{ background: "linear-gradient(to right, #174665, #174665)" }}>
        <button
          className="btn gradient-btn1 animated-border1"
          onClick={()=>{
            if(AIUser){
              navigate('/dashboard')
            }
            else navigate('/sign-up')
          }}
        >
          Sign up to win iPhone 16 pro max worth SGD 2,500
        </button>
      </div>

      <Banner />

      
      <div className="d-flex justify-content-center py-2 px-4" style={{ background: "linear-gradient(to right, #096B82, #096A81)" }}>
      {/* <TextSlider/> */}
        
      </div>

      <div className="d-flex justify-content-center py-2 pt-5 px-4" style={{ background: "linear-gradient(to right, #096B82, #096A81)" }}>
        <button
          className="btn gradient-btn animated-border"
          onClick={() => {
            navigate("/ver2/how-it-works");
          }}
        >
          Find out how you can create content for your social media channels.
        </button>
      </div>

      <Method1 />
      <Method2 />
    </div>
  );
};

export default Home_V2;
